import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-colour',
  templateUrl: './colour.component.html',
  styleUrls: ['./colour.component.scss']
})
export class ColourComponent {
  @Input() feature: any;
  @Output() featureChange = new EventEmitter<any>();

  ngOnInit() {
    if (!this.feature.value) {
      this.feature.value = {
        headerColour: '#0D4131',
        bgColour: '#EDF0EE',
        buttonColour: '#ffffff',
        buttonTextColour: '#000000'
      };
    }
  }

  onColorChange() {
    this.featureChange.emit(this.feature);
  }

  resetColors() {
    this.feature.value = {
      headerColour: '#0D4131',
      bgColour: '#EDF0EE',
      buttonColour: '#ffffff',
      buttonTextColour: '#000000'
    };
    this.featureChange.emit(this.feature);
  }
}